import { Toast, Dialog } from 'vant';
import Router from '@/router';
import { addtoneFree } from '@/api/modules/telecom';
import { settingRingOnePointMon } from '@/api/modules/unicom';
import { loginSecret, monthStatusV1, toneFreeOrderV1 } from '@/api/modules/migu';
import { MonthStatusType } from '@/model/MonthStatusType';
import { RingStatusType } from '@/model/RingStatusType';
import { diyBind } from '@/api/modules/diy';
import { CarrierType } from '@/model/CarrierType';
const sensors = window.sensorsDataAnalytic201505;
const state = {
    uploadPlayUrl: '',
    uploadPoster: '',
    uploadId: ''
};
const mutations = {
    SET_PLAYURL: (state, url) => {
        state.uploadPlayUrl = url;
    },
    SET_UPLOAD_ID: (state, id) => {
        state.uploadId = id;
    },
    SET_UPLOAD_POSTER: (state, url) => {
        state.uploadPoster = url;
    }
};
const actions = {
    diyBind: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            const data = {
                callNumber: payload,
                parentId: state.uploadId
            };
            diyBind(data)
                .then(res => {
                if (res.code === '0000') {
                    resolve(res);
                }
                else {
                    reject(res.message);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    },
    channelG({ state, rootState }, payload) {
        // let videoInstance = null
        // if (payload) {
        //   videoInstance = payload.video
        // }
        let channelCodeH = '002111H';
        let channelCodeG = '002111G';
        const hkey = rootState.app.configData.ring_mobile_channel_key1;
        if (hkey) {
            const jsonstr = rootState.app.configData[hkey];
            if (jsonstr) {
                try {
                    const channelData = JSON.parse(jsonstr);
                    channelCodeH = channelData.channelCode;
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
        const gkey = rootState.app.configData.ring_mobile_channel_key2;
        if (gkey) {
            const jsonstr = rootState.app.configData[gkey];
            if (jsonstr) {
                try {
                    const channelData = JSON.parse(jsonstr);
                    channelCodeG = channelData.channelCode;
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
        const presetProperties = sensors.getPresetProperties();
        const cookieId = presetProperties.identities.$identity_cookie_id;
        loginSecret({ loginType: 3, mobile: state.phone, channelCode: channelCodeG }).then((resG) => {
            monthStatusV1({ token: resG.data.token, channelCode: channelCodeG })
                .then((resV2) => {
                if (resV2.data === MonthStatusType.Subscribed) {
                    const params = {
                        token: resG.data.token,
                        channelCode: channelCodeG,
                        mobile: rootState.app.userInfo.phone,
                        copyRightID: payload.copyRightID,
                        contentId: payload.contentId,
                        promotionChannel: Router.currentRoute.query.pcid,
                        pid: rootState.app.selfInfo['dev-pid'],
                        uid: rootState.app.selfInfo.uid,
                        cookieId
                    };
                    toneFreeOrderV1(params)
                        .then((res) => {
                        Toast.clear();
                        if (res.code === '0000') {
                            Toast.success({
                                message: '设置成功',
                                forbidClick: true,
                                duration: 2000
                            });
                        }
                        else {
                            Toast.fail({
                                message: res.message,
                                forbidClick: true,
                                duration: 2000
                            });
                        }
                    })
                        .catch(() => {
                        Toast.clear();
                    });
                }
                else {
                    loginSecret({ loginType: 3, mobile: state.phone, channelCode: channelCodeH })
                        .then((res) => {
                        const params = {
                            token: res.data.token,
                            channelCode: channelCodeH,
                            mobile: rootState.app.userInfo.phone,
                            copyRightID: payload.copyRightID,
                            contentId: payload.contentId,
                            promotionChannel: Router.currentRoute.query.pcid,
                            pid: rootState.app.selfInfo['dev-pid'],
                            uid: rootState.app.selfInfo.uid,
                            cookieId
                        };
                        toneFreeOrderV1(params).then((res) => {
                            if (res.code === '0000') {
                                Toast.success({
                                    message: '设置成功',
                                    forbidClick: true,
                                    duration: 2000
                                    // onClose: () => {}
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 2000
                                    // onClose: () => {}
                                });
                            }
                        });
                    });
                }
            });
        });
    },
    channelH({ rootState }, payload) {
        let channelCodeG = '002111G';
        let channelCodeH = '002111H';
        const gkey = rootState.app.configData.ring_mobile_channel_key2;
        if (gkey) {
            const jsonstr = rootState.app.configData[gkey];
            if (jsonstr) {
                try {
                    const channelData = JSON.parse(jsonstr);
                    channelCodeG = channelData.channelCode;
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
        const hkey = rootState.app.configData.ring_mobile_channel_key1;
        if (hkey) {
            const jsonstr = rootState.app.configData[hkey];
            if (jsonstr) {
                try {
                    const channelData = JSON.parse(jsonstr);
                    channelCodeH = channelData.channelCode;
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
        const presetProperties = sensors.getPresetProperties();
        const cookieId = presetProperties.identities.$identity_cookie_id;
        const token = rootState.app.userInfo.TOKEN ? rootState.app.userInfo.TOKEN : payload.token;
        monthStatusV1({ token, channelCode: channelCodeH })
            .then((resV1) => {
            if (resV1.data === MonthStatusType.Subscribed) {
                loginSecret({ loginType: 3, mobile: rootState.app.userInfo.phone, channelCode: channelCodeG }).then((res) => {
                    const params = {
                        token: res.data.token,
                        channelCode: channelCodeG,
                        mobile: rootState.app.userInfo.phone,
                        copyRightID: payload.copyRightID,
                        contentId: payload.contentId,
                        promotionChannel: Router.currentRoute.query.pcid,
                        pid: rootState.app.selfInfo['dev-pid'],
                        uid: rootState.app.selfInfo.uid,
                        cookieId
                    };
                    toneFreeOrderV1(params)
                        .then((res) => {
                        if (res.code === '0000') {
                            Toast.success({
                                message: '设置成功',
                                forbidClick: true,
                                duration: 2000
                            });
                        }
                        else {
                            Toast.fail({
                                message: res.message,
                                forbidClick: true,
                                duration: 2000
                            });
                        }
                    });
                });
            }
            else {
                const params = {
                    token,
                    channelCode: channelCodeH,
                    mobile: rootState.app.userInfo.phone,
                    copyRightID: payload.copyRightID,
                    contentId: payload.contentId,
                    promotionChannel: Router.currentRoute.query.pcid,
                    pid: rootState.app.selfInfo['dev-pid'],
                    uid: rootState.app.selfInfo.uid,
                    cookieId
                };
                toneFreeOrderV1(params).then((res) => {
                    if (res.code === '0000') {
                        Toast.success({
                            message: '设置成功',
                            forbidClick: true,
                            duration: 2000
                        });
                    }
                    else {
                        Toast.fail({
                            message: res.message,
                            forbidClick: true,
                            duration: 2000
                        });
                    }
                });
            }
        });
    },
    settingRingtone({ dispatch, state, rootState }, payload) {
        const { ringId: contentId, copyRightID } = payload;
        const params = {
            token: rootState.app.userInfo.TOKEN,
            mobile: rootState.app.userInfo.phone,
            copyRightID: copyRightID,
            contentId: contentId,
            promotionChannel: Router.currentRoute.query.pcid,
            pid: rootState.app.selfInfo['dev-pid'],
            uid: rootState.app.selfInfo.uid
        };
        switch (rootState.ringtone.carrierType) {
            case CarrierType.MIGU: {
                Toast.loading({ forbidClick: true });
                dispatch('ringtone/getRingStatus', { token: rootState.app.userInfo.TOKEN }, { root: true }).then((res) => {
                    // 移动，已开通视频彩铃功能，且3：视频彩铃播放功能处于开启状态
                    // 移动，已开通视频彩铃功能，且2：视频彩铃播放功能处于关闭状态
                    if (res.data === RingStatusType.RingToneOnPlay || res.data === RingStatusType.RingToneOffPlay) {
                        if (rootState.app.configData.use_g_privince && rootState.app.configData.use_g_privince.includes(state.phoneProvince)) {
                            dispatch('channelG', { ...payload, ...params });
                            return;
                        }
                        dispatch('channelH', { ...payload, ...params });
                    }
                    else if (res.data === RingStatusType.NoRingTone) {
                        if (rootState.app.configData.use_h_privince && rootState.app.configData.use_h_privince.includes(state.phoneProvince)) {
                            dispatch('channelH', { ...payload, ...params });
                            return;
                        }
                        // 变更渠道重新登入
                        // 1:未开通视频彩铃功能。
                        //  dispatch('channelH', payload)
                        dispatch('channelG', { ...payload, ...params });
                    }
                });
                break;
            }
            case CarrierType.CUCC: {
                settingRingOnePointMon({
                    phone: rootState.app.userInfo.phone,
                    ringId: contentId,
                    promotionChannel: Router.currentRoute.query.pcid,
                    pid: rootState.app.selfInfo['dev-pid'],
                    uid: rootState.app.selfInfo.uid
                })
                    .then((res) => {
                    Toast.clear();
                    if (res.code === '0000') {
                        Toast.success({
                            message: '设置成功',
                            forbidClick: true,
                            duration: 1500
                        });
                    }
                    else {
                        Toast.fail({
                            message: res.message || '设置失败',
                            forbidClick: true,
                            duration: 1500
                        });
                    }
                })
                    .catch((err) => { console.log(err); });
                break;
            }
            case CarrierType.TELECOM: {
                addtoneFree({
                    phoneNumber: rootState.app.userInfo.phone,
                    toneCode: contentId,
                    promotionChannel: Router.currentRoute.query.pcid,
                    pid: rootState.app.selfInfo['dev-pid'],
                    uid: rootState.app.selfInfo.uid,
                    packageId: '',
                    cookieId: ''
                })
                    .then((res) => {
                    Toast.clear();
                    if (res.code === '0000') {
                        Toast.success({
                            message: '设置成功',
                            forbidClick: true,
                            duration: 1500
                        });
                    }
                    else {
                        if (res.message === '用户不存在') {
                            Dialog.alert({
                                title: '温馨提示',
                                message: '抱歉，您的视频彩铃功能未开通。请先在应用商店下载【爱音乐】app，然后在【我的】-【会员中心】开通功能。',
                                confirmButtonText: '我知道了',
                                className: 'telecom-msg sendMsg-dialog '
                            });
                        }
                        else {
                            Toast.fail({
                                message: res.message || '设置失败',
                                forbidClick: true,
                                duration: 1500
                            });
                        }
                    }
                });
                break;
            }
        }
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
